/* eslint-disable */
import { useState, useEffect } from 'react';
import {
  // Box,
  // Grid,
  makeStyles,
  Typography,
  // Card,
  // CardContent,
  // CardActions,
  Button,
  // IconButton,
  Chip,
  // CircularProgress,
  // Divider,
} from '@material-ui/core';
import {
  // CloudDownload as DownloadIcon,
  OpenInNew as OpenIcon,
  Folder as FolderIcon,
  InsertDriveFile as FileIcon,
  Refresh as RefreshIcon,
  // GetApp as GetAppIcon,
} from '@material-ui/icons';
import ContentWrapper from '../Wrappers/ContentWrapper';
import RoundedButton from '../Shared/RoundedButton';
import theme from '../../config/theme';
import emptyDataIcon from '../../assets/placeholders/emptyState.svg';
import { getGoogleDriveResources } from '../../helpers/googleDriveDirectAccess';

const useStyles = makeStyles(() => ({
  gridItem: {
    border: '1px solid rgba(0, 0, 0, 0.12)',
    padding: theme.spacing(3),
    borderRadius: theme.shape.borderRadius,
    height: 'calc(100vh - 400px)',
    overflow: 'auto',
  },
  resourceCard: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 16,
    border: '1px solid rgba(0, 0, 0, 0.06)',
    backgroundColor: '#ffffff',
    backdropFilter: 'blur(10px)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    cursor: 'pointer',
    position: 'relative',
    overflow: 'hidden',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)',
    '&:hover': {
      transform: 'translateY(-4px) scale(1.01)',
      boxShadow: '0 12px 24px rgba(0, 0, 0, 0.12), 0 8px 16px rgba(0, 0, 0, 0.16)',
      borderColor: 'rgba(0, 0, 0, 0.1)',
      '& $resourceIcon': {
        transform: 'scale(1.05)',
      },
    },
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: 2,
      background: 'linear-gradient(90deg, #007AFF 0%, #5856D6 50%, #AF52DE 100%)',
      opacity: 0,
      transition: 'opacity 0.3s ease',
    },
    '&:hover::before': {
      opacity: 1,
    },
  },
  cardContent: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(3),
    paddingBottom: theme.spacing(2),
  },
  resourceIcon: {
    fontSize: 52,
    marginBottom: theme.spacing(2),
    alignSelf: 'center',
    transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1))',
  },
  folderIcon: {
    color: '#007AFF',
  },
  fileIcon: {
    color: '#5856D6',
  },
  resourceTitle: {
    fontWeight: 700,
    marginBottom: theme.spacing(1),
    color: '#1D1D1F',
    fontSize: '1.1rem',
    lineHeight: 1.3,
  },
  resourceDescription: {
    color: '#86868B',
    flexGrow: 1,
    fontSize: '0.9rem',
    lineHeight: 1.4,
  },
  resourceMeta: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing(2),
  },
  emptyDataWidget: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 400,
    flexDirection: 'column',
  },
  emptyDataTitle: {
    marginTop: theme.spacing(2),
    color: theme.colors.blue2,
  },
  statsBox: {
    textAlign: 'center',
    padding: theme.spacing(3),
    backgroundColor: theme.colors.lightBlue,
    borderRadius: 12,
    color: 'white',
    position: 'relative',
    overflow: 'hidden',
    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 8px 20px rgba(0, 0, 0, 0.2)',
    },
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: 3,
      background: 'linear-gradient(90deg, rgba(255,255,255,0.3) 0%, rgba(255,255,255,0.6) 50%, rgba(255,255,255,0.3) 100%)',
    },
  },
  statsNumber: {
    fontSize: 32,
    fontWeight: 800,
    marginBottom: theme.spacing(0.5),
    textShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
  },
  statsLabel: {
    fontSize: 13,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: 1.2,
    opacity: 0.9,
  },
  divider: {
    width: '100%',
    margin: theme.spacing(3, 0),
  },
  actionButton: {
    height: 40,
    marginRight: theme.spacing(1),
  },
  cardActions: {
    padding: theme.spacing(2, 3),
    paddingTop: 0,
    '& .MuiButton-root': {
      borderRadius: 8,
      textTransform: 'none',
      fontWeight: 600,
      fontSize: '0.875rem',
      padding: theme.spacing(0.75, 2),
      color: '#007AFF',
      '&:hover': {
        backgroundColor: 'rgba(0, 122, 255, 0.08)',
      },
    },
    '& .MuiIconButton-root': {
      borderRadius: 8,
      color: '#86868B',
      '&:hover': {
        backgroundColor: 'rgba(134, 134, 139, 0.08)',
        color: '#007AFF',
      },
    },
  },
  chartContainer: {
    padding: theme.spacing(3),
    border: '1px solid rgba(0, 0, 0, 0.06)',
    borderRadius: 16,
    backgroundColor: '#ffffff',
    height: 'calc(100vh - 400px)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)',
  },
  chartTitle: {
    fontWeight: 700,
    color: '#1D1D1F',
    marginBottom: theme.spacing(3),
    textAlign: 'center',
  },
  pieChart: {
    marginBottom: theme.spacing(3),
  },
  pieSlice: {
    transition: 'all 0.3s ease',
  },
  chartCenterNumber: {
    fontSize: '24px',
    fontWeight: 'bold',
    fill: '#1D1D1F',
  },
  chartCenterLabel: {
    fontSize: '12px',
    fill: '#86868B',
    textTransform: 'uppercase',
    letterSpacing: '1px',
  },
  chartLegend: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    width: '100%',
  },
  legendItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1, 2),
    borderRadius: 8,
    backgroundColor: '#f8f9fa',
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: '#e9ecef',
    },
  },
  legendColor: {
    width: 16,
    height: 16,
    borderRadius: 4,
    flexShrink: 0,
  },
}));

const GOOGLE_DRIVE_FOLDER_ID = '1g_jpa1rkycfdaq-NizLUZkFQZ-tDaagK';
const GOOGLE_DRIVE_FOLDER_URL = `https://drive.google.com/drive/u/4/folders/${GOOGLE_DRIVE_FOLDER_ID}`;

// // Mock data for demonstration (replace with real data from Google Drive API)
// const mockGoogleDriveData = [
//   {
//     id: 'folder1',
//     name: 'Руководства врачам',
//     type: 'folder',
//     itemCount: 8,
//     description: 'Медицинские руководства и протоколы AllergiEnd',
//     lastModified: '2024-01-15',
//     url: 'https://drive.google.com/drive/folders/1subfolder1',
//   },
//   {
//     id: 'folder2',
//     name: 'Материалы для пациентов',
//     type: 'folder',
//     itemCount: 12,
//     description: 'Информационные брошюры и инструкции для пациентов',
//     lastModified: '2024-01-10',
//     url: 'https://drive.google.com/drive/folders/1subfolder2',
//   },
//   {
//     id: 'file1',
//     name: 'Протокол проведения AllergiEnd',
//     type: 'file',
//     size: '2.3 MB',
//     mimeType: 'application/pdf',
//     description: 'Подробный протокол проведения процедуры',
//     lastModified: '2024-01-12',
//     url: 'https://drive.google.com/file/d/1example1/view',
//   },
//   {
//     id: 'file2',
//     name: 'Видео инструкция',
//     type: 'file',
//     size: '25.1 MB',
//     mimeType: 'video/mp4',
//     description: 'Демонстрация процедуры AllergiEnd',
//     lastModified: '2024-01-08',
//     url: 'https://drive.google.com/file/d/1example2/view',
//   },
//   {
//     id: 'folder3',
//     name: 'Клинические исследования',
//     type: 'folder',
//     itemCount: 6,
//     description: 'Результаты клинических исследований и статистика',
//     lastModified: '2024-01-05',
//     url: 'https://drive.google.com/drive/folders/1subfolder3',
//   },
//   {
//     id: 'file3',
//     name: 'Презентация для конференции',
//     type: 'file',
//     size: '8.7 MB',
//     mimeType: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
//     description: 'Презентация о методике AllergiEnd',
//     lastModified: '2024-01-03',
//     url: 'https://drive.google.com/file/d/1example3/view',
//   },
// ];

const AllergiEndResources = () => {
  const classes = useStyles();

  // Use static resources from helper as main data
  const [resources, setResources] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchGoogleDriveFiles = async () => {
    setLoading(true);
    setError(null);

    try {
      const API_KEY = process.env.REACT_APP_GOOGLE_DRIVE_API_KEY;

      console.log('🔄 Loading Google Drive resources...');
      console.log('API key:', API_KEY ? '✅ Available' : '❌ Missing');

      // Use universal helper
      const driveResources = await getGoogleDriveResources({
        useAPI: !!API_KEY,
        useStatic: true,
        apiKey: API_KEY,
      });

      if (driveResources.length > 0) {
        // Format data for component
        const formattedResources = driveResources.map(file => ({
          id: file.id,
          name: file.name,
          type: file.type,
          size: file.size ? formatBytes(file.size) : file.size,
          mimeType: file.mimeType,
          description: file.description || getDefaultDescription(file.mimeType),
          lastModified: file.lastModified ?
            (typeof file.lastModified === 'string' && file.lastModified.includes('T') ?
              new Date(file.lastModified).toLocaleDateString('en-US') :
              file.lastModified) :
            new Date().toLocaleDateString('en-US'),
          url: file.url,
          downloadUrl: file.downloadUrl || file.url,
          itemCount: file.itemCount,
          source: file.source,
        }));

        setResources(formattedResources);
        console.log(`✅ Loaded ${formattedResources.length} items via ${formattedResources[0]?.source}`);
      } else {
        console.warn('⚠️ Failed to load resources');
        setError('Failed to load resources');
      }
    } catch (error) {
      console.error('❌ Error loading Google Drive files:', error);
      setError(`Loading error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleRefresh = () => {
    fetchGoogleDriveFiles();
  };

  // Load data on component mount
  useEffect(() => {
    fetchGoogleDriveFiles();
  }, []);

  const formatBytes = (bytes) => {
    if (!bytes) return 'N/A';
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return Math.round(bytes / Math.pow(1024, i) * 100) / 100 + ' ' + sizes[i];
  };

  const getDefaultDescription = (mimeType) => {
    if (mimeType?.includes('pdf')) return 'PDF document';
    if (mimeType?.includes('video')) return 'Video file';
    if (mimeType?.includes('presentation')) return 'Presentation';
    if (mimeType?.includes('document')) return 'Text document';
    if (mimeType?.includes('spreadsheet')) return 'Spreadsheet';
    if (mimeType?.includes('folder')) return 'Folder with files';
    return 'File';
  };

  const handleOpenExternal = () => {
    window.open(GOOGLE_DRIVE_FOLDER_URL, '_blank', 'noopener,noreferrer');
  };

  const handleResourceClick = (resource) => {
    window.open(resource.url, '_blank', 'noopener,noreferrer');
  };

  const getFileIcon = (type, mimeType) => {
    if (type === 'folder') {
      return <FolderIcon className={`${classes.resourceIcon} ${classes.folderIcon}`} />;
    }
    return <FileIcon className={`${classes.resourceIcon} ${classes.fileIcon}`} />;
  };

  const getFileTypeChip = (type, mimeType, itemCount) => {
    if (type === 'folder') {
      return <Chip label={`${itemCount} items`} size='small' color='primary' />;
    }

    if (mimeType?.includes('pdf')) return <Chip label='PDF' size='small' color='secondary' />;
    if (mimeType?.includes('video')) return <Chip label='Video' size='small' style={{
      backgroundColor: '#f44336',
      color: 'white',
    }} />;
    if (mimeType?.includes('presentation')) return <Chip label='Presentation' size='small' style={{
      backgroundColor: '#ff9800',
      color: 'white',
    }} />;
    return <Chip label='File' size='small' color='default' />;
  };

  // Statistics
  const folders = resources.filter(r => r.type === 'folder');
  const files = resources.filter(r => r.type === 'file');
  const totalItems = folders.reduce((sum, folder) => sum + (folder.itemCount || 0), 0) + files.length;

  if (error) {
    return (
      <ContentWrapper>
        <div className={classes.emptyDataWidget}>
          <img alt='Error' src={emptyDataIcon} />
          <Typography className={classes.emptyDataTitle}>
            Failed to load resources
          </Typography>
          <Button
            onClick={handleRefresh}
            startIcon={<RefreshIcon />}
            style={{ marginTop: 16 }}
          >
            Try again
          </Button>
        </div>
      </ContentWrapper>
    );
  }
  //   setLoading(true);
  //   setError(null);
  //
  //   try {
  //     const API_KEY = process.env.REACT_APP_GOOGLE_DRIVE_API_KEY;
  //
  //     console.log('🔄 Загрузка ресурсов Google Drive...');
  //     console.log('API ключ:', API_KEY ? '✅ Есть' : '❌ Отсутствует');
  //
  //     // Используем универсальный хелпер
  //     const driveResources = await getGoogleDriveResources({
  //       useAPI: true,
  //       useStatic: true,
  //       apiKey: API_KEY,
  //     });
  //
  //     console.log(driveResources);
  //     if (driveResources.length > 0) {
  //       // Форматируем данные для компонента
  //       const formattedResources = driveResources.map(file => ({
  //         id: file.id,
  //         name: file.name,
  //         type: file.type,
  //         size: file.size ? formatBytes(file.size) : file.size,
  //         mimeType: file.mimeType,
  //         description: file.description || getDefaultDescription(file.mimeType),
  //         lastModified: file.lastModified ?
  //           (typeof file.lastModified === 'string' && file.lastModified.includes('T') ?
  //             new Date(file.lastModified).toLocaleDateString('ru-RU') :
  //             file.lastModified) :
  //           new Date().toLocaleDateString('ru-RU'),
  //         url: file.url,
  //         downloadUrl: file.downloadUrl || file.url,
  //         itemCount: file.itemCount,
  //         source: file.source,
  //       }));
  //
  //       setResources(formattedResources);
  //       console.log(`✅ Загружено ${formattedResources.length} элементов через ${formattedResources[0]?.source}`);
  //       console.log(formattedResources);
  //     } else {
  //       console.warn('⚠️ Не удалось загрузить ресурсы, используем мок-данные');
  //       setResources([...mockGoogleDriveData]);
  //     }
  //   } catch (error) {
  //     console.error('❌ Ошибка при загрузке файлов из Google Drive:', error);
  //     setError(`Ошибка загрузки: ${error.message}`);
  //     // Fallback на мок-данные
  //     setResources([...mockGoogleDriveData]);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
//
//   const handleRefresh = () => {
//     fetchGoogleDriveFiles();
//   };
//
//   // Загружаем данные при монтировании компонента
//   useEffect(() => {
//     fetchGoogleDriveFiles();
//   }, []);
//
//   const formatBytes = (bytes) => {
//     if (!bytes) return 'N/A';
//     const sizes = ['Bytes', 'KB', 'MB', 'GB'];
//     const i = Math.floor(Math.log(bytes) / Math.log(1024));
//     return Math.round(bytes / Math.pow(1024, i) * 100) / 100 + ' ' + sizes[i];
//   };
//
//   const getMimeTypeFromTitle = (title) => {
//     const ext = title.toLowerCase().split('.').pop();
//     const mimeTypes = {
//       'pdf': 'application/pdf',
//       'doc': 'application/msword',
//       'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
//       'ppt': 'application/vnd.ms-powerpoint',
//       'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
//       'xls': 'application/vnd.ms-excel',
//       'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
//       'mp4': 'video/mp4',
//       'avi': 'video/avi',
//       'mov': 'video/quicktime',
//       'jpg': 'image/jpeg',
//       'jpeg': 'image/jpeg',
//       'png': 'image/png',
//       'gif': 'image/gif',
//     };
//     return mimeTypes[ext] || 'application/octet-stream';
//   };
//
//   const getDefaultDescription = (mimeType) => {
//     if (mimeType?.includes('pdf')) return 'PDF документ';
//     if (mimeType?.includes('video')) return 'Видео файл';
//     if (mimeType?.includes('presentation')) return 'Презентация';
//     if (mimeType?.includes('document')) return 'Текстовый документ';
//     if (mimeType?.includes('spreadsheet')) return 'Таблица';
//     if (mimeType?.includes('folder')) return 'Папка с файлами';
//     return 'Файл';
//   };
//
//   const handleOpenExternal = () => {
//     window.open(GOOGLE_DRIVE_FOLDER_URL, '_blank', 'noopener,noreferrer');
//   };
//
//   const handleResourceClick = (resource) => {
//     window.open(resource.url, '_blank', 'noopener,noreferrer');
//   };
//
//   const getFileIcon = (type, mimeType) => {
//     if (type === 'folder') {
//       return <FolderIcon className={`${classes.resourceIcon} ${classes.folderIcon}`} />;
//     }
//     return <FileIcon className={`${classes.resourceIcon} ${classes.fileIcon}`} />;
//   };
//
//   const getFileTypeChip = (type, mimeType, itemCount) => {
//     if (type === 'folder') {
//       return <Chip label={`${itemCount} элементов`} size="small" color="primary" />;
//     }
// ``
//     if (mimeType?.includes('pdf')) return <Chip label="PDF" size="small" color="secondary" />;
//     if (mimeType?.includes('video')) return <Chip label="Видео" size="small" style={{ backgroundColor: '#f44336', color: 'white' }} />;
//     if (mimeType?.includes('presentation')) return <Chip label="Презентация" size="small" style={{ backgroundColor: '#ff9800', color: 'white' }} />;
//     return <Chip label="Файл" size="small" color="default" />;
//   };
//
//   // Statistics
//   const folders = resources.filter(r => r.type === 'folder');
//   const files = resources.filter(r => r.type === 'file');
//   const totalItems = folders.reduce((sum, folder) => sum + folder.itemCount, 0) + files.length;
//
//   if (error) {
//     return (
//       <ContentWrapper>
//         <div className={classes.emptyDataWidget}>
//           <img alt="Ошибка" src={emptyDataIcon} />
//           <Typography className={classes.emptyDataTitle}>
//             Ошибка загрузки ресурсов
//           </Typography>
//           <Button
//             onClick={handleRefresh}
//             startIcon={<RefreshIcon />}
//             style={{ marginTop: 16 }}
//           >
//             Попробовать снова
//           </Button>
//         </div>
//       </ContentWrapper>
//     );
//   }

  return (
    <ContentWrapper
      titleText='AllergiEnd Resources'
      containerStyle={{ paddingBottom: 0 }}
      actions={
        <RoundedButton
          size='small'
          color='primary'
          variant='contained'
          className={classes.actionButton}
          onClick={handleOpenExternal}
          startIcon={<OpenIcon />}
        >
          Open in Drive
        </RoundedButton>
      }
    >
      {/*<Box p={2}>*/}
      {/*  /!* Statistics *!/*/}
      {/*  <Grid container spacing={3} style={{ marginBottom: 24 }}>*/}
      {/*    <Grid item xs={12} sm={4}>*/}
      {/*      <Box className={classes.statsBox}>*/}
      {/*        <Typography className={classes.statsNumber}>*/}
      {/*          {folders.length}*/}
      {/*        </Typography>*/}
      {/*        <Typography className={classes.statsLabel}>*/}
      {/*          Folders*/}
      {/*        </Typography>*/}
      {/*      </Box>*/}
      {/*    </Grid>*/}
      {/*    <Grid item xs={12} sm={4}>*/}
      {/*      <Box className={classes.statsBox} style={{ backgroundColor: theme.colors.blue3 }}>*/}
      {/*        <Typography className={classes.statsNumber}>*/}
      {/*          {files.length}*/}
      {/*        </Typography>*/}
      {/*        <Typography className={classes.statsLabel}>*/}
      {/*          Files*/}
      {/*        </Typography>*/}
      {/*      </Box>*/}
      {/*    </Grid>*/}
      {/*    <Grid item xs={12} sm={4}>*/}
      {/*      <Box className={classes.statsBox} style={{ backgroundColor: theme.colors.blue4 }}>*/}
      {/*        <Typography className={classes.statsNumber}>*/}
      {/*          {totalItems}*/}
      {/*        </Typography>*/}
      {/*        <Typography className={classes.statsLabel}>*/}
      {/*          Total Items*/}
      {/*        </Typography>*/}
      {/*      </Box>*/}
      {/*    </Grid>*/}
      {/*  </Grid>*/}

      {/*  <Divider className={classes.divider} />*/}

      {/*  /!* Main content *!/*/}
      {/*  <Grid container spacing={3}>*/}
      {/*    /!* Resources Grid *!/*/}
      {/*    <Grid item xs={12} md={8}>*/}
      {/*      <div className={classes.gridItem}>*/}
      {/*        {loading ? (*/}
      {/*          <Box display='flex' justifyContent='center' alignItems='center' minHeight='300px'>*/}
      {/*            <CircularProgress />*/}
      {/*            <Typography variant='h6' style={{ marginLeft: 16 }}>*/}
      {/*              Loading resources...*/}
      {/*            </Typography>*/}
      {/*          </Box>*/}
      {/*        ) : (*/}
      {/*          <Grid container spacing={3}>*/}
      {/*            {resources.map((resource) => (*/}
      {/*              <Grid item xs={12} sm={6} md={6} lg={4} key={resource.id}>*/}
      {/*                <Card*/}
      {/*                  className={classes.resourceCard}*/}
      {/*                  onClick={() => handleResourceClick(resource)}*/}
      {/*                >*/}
      {/*                  <CardContent className={classes.cardContent}>*/}
      {/*                    {getFileIcon(resource.type, resource.mimeType)}*/}

      {/*                    <Typography variant='h6' className={classes.resourceTitle} noWrap>*/}
      {/*                      {resource.name}*/}
      {/*                    </Typography>*/}

      {/*                    <Typography*/}
      {/*                      variant='body2'*/}
      {/*                      className={classes.resourceDescription}*/}
      {/*                      style={{ minHeight: 40 }}*/}
      {/*                    >*/}
      {/*                      {resource.description}*/}
      {/*                    </Typography>*/}

      {/*                    <Box className={classes.resourceMeta}>*/}
      {/*                      {getFileTypeChip(resource.type, resource.mimeType, resource.itemCount)}*/}
      {/*                      {resource.size && (*/}
      {/*                        <Typography variant='caption' color='textSecondary'>*/}
      {/*                          {resource.size}*/}
      {/*                        </Typography>*/}
      {/*                      )}*/}
      {/*                    </Box>*/}

      {/*                    <Typography variant='caption' color='textSecondary'*/}
      {/*                                style={{ marginTop: 8 }}>*/}
      {/*                      Updated: {resource.lastModified}*/}
      {/*                    </Typography>*/}
      {/*                  </CardContent>*/}

      {/*                  <CardActions className={classes.cardActions}>*/}
      {/*                    <Button*/}
      {/*                      size='small'*/}
      {/*                      startIcon={<OpenIcon />}*/}
      {/*                      onClick={(e) => {*/}
      {/*                        e.stopPropagation();*/}
      {/*                        handleResourceClick(resource);*/}
      {/*                      }}*/}
      {/*                    >*/}
      {/*                      Open*/}
      {/*                    </Button>*/}
      {/*                    {resource.type === 'file' && (*/}
      {/*                      <IconButton*/}
      {/*                        size='small'*/}
      {/*                        onClick={(e) => {*/}
      {/*                          e.stopPropagation();*/}
      {/*                          window.open(resource.url.replace('/view', '/download'), '_blank');*/}
      {/*                        }}*/}
      {/*                      >*/}
      {/*                        <DownloadIcon />*/}
      {/*                      </IconButton>*/}
      {/*                    )}*/}
      {/*                  </CardActions>*/}
      {/*                </Card>*/}
      {/*              </Grid>*/}
      {/*            ))}*/}
      {/*          </Grid>*/}
      {/*        )}*/}
      {/*      </div>*/}
      {/*    </Grid>*/}

      {/*    /!* Statistics Chart *!/*/}
      {/*    <Grid item xs={12} md={4}>*/}
      {/*      <div className={classes.chartContainer}>*/}
      {/*        <Typography variant='h6' className={classes.chartTitle}>*/}
      {/*          File Distribution*/}
      {/*        </Typography>*/}
      {/*        <div className={classes.pieChart}>*/}
      {/*          <svg width='200' height='200' viewBox='0 0 200 200'>*/}
      {/*            <circle*/}
      {/*              cx='100'*/}
      {/*              cy='100'*/}
      {/*              r='80'*/}
      {/*              fill='none'*/}
      {/*              stroke='#f0f0f0'*/}
      {/*              strokeWidth='20'*/}
      {/*            />*/}
      {/*            <circle*/}
      {/*              cx='100'*/}
      {/*              cy='100'*/}
      {/*              r='80'*/}
      {/*              fill='none'*/}
      {/*              stroke='#007AFF'*/}
      {/*              strokeWidth='20'*/}
      {/*              strokeDasharray={`${(folders.length / (folders.length + files.length)) * 502.4} 502.4`}*/}
      {/*              strokeDashoffset='0'*/}
      {/*              transform='rotate(-90 100 100)'*/}
      {/*              className={classes.pieSlice}*/}
      {/*            />*/}
      {/*            <circle*/}
      {/*              cx='100'*/}
      {/*              cy='100'*/}
      {/*              r='80'*/}
      {/*              fill='none'*/}
      {/*              stroke='#5856D6'*/}
      {/*              strokeWidth='20'*/}
      {/*              strokeDasharray={`${(files.length / (folders.length + files.length)) * 502.4} 502.4`}*/}
      {/*              strokeDashoffset={`-${(folders.length / (folders.length + files.length)) * 502.4}`}*/}
      {/*              transform='rotate(-90 100 100)'*/}
      {/*              className={classes.pieSlice}*/}
      {/*            />*/}
      {/*            <text x='100' y='95' textAnchor='middle' className={classes.chartCenterNumber}>*/}
      {/*              {folders.length + files.length}*/}
      {/*            </text>*/}
      {/*            <text x='100' y='115' textAnchor='middle' className={classes.chartCenterLabel}>*/}
      {/*              Total*/}
      {/*            </text>*/}
      {/*          </svg>*/}
      {/*        </div>*/}
      {/*        <div className={classes.chartLegend}>*/}
      {/*          <div className={classes.legendItem}>*/}
      {/*            <div className={classes.legendColor} style={{ backgroundColor: '#007AFF' }}></div>*/}
      {/*            <Typography variant='body2'>*/}
      {/*              Folders ({folders.length})*/}
      {/*            </Typography>*/}
      {/*          </div>*/}
      {/*          <div className={classes.legendItem}>*/}
      {/*            <div className={classes.legendColor} style={{ backgroundColor: '#5856D6' }}></div>*/}
      {/*            <Typography variant='body2'>*/}
      {/*              Files ({files.length})*/}
      {/*            </Typography>*/}
      {/*          </div>*/}
      {/*        </div>*/}
      {/*      </div>*/}
      {/*    </Grid>*/}
      {/*  </Grid>*/}
      {/*</Box>*/}
    </ContentWrapper>
  );
};

export default AllergiEndResources;
